// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1H8Ta","empty":"ModalGraph_empty__tmlPd"};